{
  "id": "campaign-007",
  "name": "Dewy Nook",
  "seed": "campaign:7",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".........",
    ".........",
    "..#......",
    "........T",
    ".......*.",
    ".......*.",
    ".......*.",
    "......T..",
    ".........",
    "S........"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 5,
      "y": 8
    }
  ],
  "pickups": [
    {
      "kind": "coin",
      "x": 6,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 0
    }
  ],
  "generatorVersion": 3,
  "level": 7,
  "biome": "backyard",
  "par": {
    "reel": 2640,
    "push": 2574,
    "selfPropelled": 2328,
    "tractor": 2120,
    "zeroTurn": 1496,
    "fairway": 924
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 3,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 20
    }
  }
}
